import { __makeTemplateObject } from "tslib";
import React from 'react';
import { Edit } from '@ringcentral/juno-icon';
import { flexCenterStyle, palette2, setOpacity, styled, } from '../../../foundation';
import { RcIcon } from '../../Icon';
var StyledMask = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n\n  width: 100%;\n  height: 27.5%;\n  background-color: ", ";\n  color: ", ";\n  text-align: center;\n  ", "\n"], ["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n\n  width: 100%;\n  height: 27.5%;\n  background-color: ", ";\n  color: ", ";\n  text-align: center;\n  ", "\n"])), setOpacity(palette2('neutral', 'b06'), '56'), palette2('neutral', 'f01'), flexCenterStyle);
var defaultChildren = React.createElement(RcIcon, { size: "small", symbol: Edit });
var RcAvatarMask = function (_a) {
    var className = _a.className, _b = _a.children, children = _b === void 0 ? defaultChildren : _b;
    return React.createElement(StyledMask, { className: className }, children);
};
export { RcAvatarMask };
var templateObject_1;
